import { gql } from '@apollo/client'

export const ALL_COLLECTION_CASES = gql`
    query AllCollectionCases(
        $first: Int!
        $after: Int
        $status: String
        $searchTerm: String
        $orderBy: [String]
        $driverId: Int
        $branchId: Int
        $branchIds: [Int]
        $driverBillingDay: Int
        $driverStages: [Int]
        $carStatusIn: [String]
        $driverTags: [String]
        $hasPaymentPlan: Boolean
        $hasPaymentSchedule: Boolean
        $driverInOffice: Boolean
        $autoCharge: Boolean
        $retriesExhausted: Boolean
        $openingBalanceGte: Decimal
        $openingBalanceLte: Decimal
        $openedAtDateGte: Date
        $openedAtDateLte: Date
        $assignedToId: Int
        $assignedToIds: [ID]
    ) {
        allCollectionCases(
            first: $first
            after: $after
            status: $status
            searchTerm: $searchTerm
            orderBy: $orderBy
            driverId: $driverId
            branchId: $branchId
            branchIds: $branchIds
            driverBillingDay: $driverBillingDay
            driverStages: $driverStages
            carStatusIn: $carStatusIn
            driverTags: $driverTags
            hasPaymentPlan: $hasPaymentPlan
            hasPaymentSchedule: $hasPaymentSchedule
            driverInOffice: $driverInOffice
            autoCharge: $autoCharge
            retriesExhausted: $retriesExhausted
            openingBalance_Gte: $openingBalanceGte
            openingBalance_Lte: $openingBalanceLte
            openedAt_Date_Gte: $openedAtDateGte
            openedAt_Date_Lte: $openedAtDateLte
            assignedToId: $assignedToId
            assignedToIds: $assignedToIds
        ) {
            id
            driverId
            driverName
            driverBranchName
            driverPhone
            driverAutoCharge
            driverHasPaymentMethod
            driverInOffice
            driverHasMobileApp
            driverActiveCarId
            driverActiveCarIsDisabled
            driverActiveCarStatus
            pendingScheduleCount
            outstandingBalance
            status
            openingBalance
            amountCollected
            driverChargeableBalance
            openedAt
            closedAt
            nextActionAt
            nextActionSummary
            chargeAttempts
            maxChargeAttempts
            nextChargeAttemptAt
            assignedTo {
                id
                gid
                firstName
                lastName
                username
            }
            driverTags {
                name
                color
            }
            driverBillingDay
            driverWeeklyBillingNotes
            latestActivityType
            latestActivityNote
            latestActivityAt
            dateAdded
            dateModified
        }
    }
`

export const COLLECTION_CASES_COUNT = gql`
    query CollectionCasesCount(
        $status: String
        $searchTerm: String
        $driverId: Int
        $branchId: Int
        $branchIds: [Int]
        $driverBillingDay: Int
        $driverStages: [Int]
        $carStatusIn: [String]
        $driverTags: [String]
        $hasPaymentPlan: Boolean
        $hasPaymentSchedule: Boolean
        $driverInOffice: Boolean
        $autoCharge: Boolean
        $retriesExhausted: Boolean
        $openingBalanceGte: Decimal
        $openingBalanceLte: Decimal
        $openedAtDateGte: Date
        $openedAtDateLte: Date
        $assignedToId: Int
        $assignedToIds: [ID]
    ) {
        collectionCasesCount(
            status: $status
            searchTerm: $searchTerm
            driverId: $driverId
            branchId: $branchId
            branchIds: $branchIds
            driverBillingDay: $driverBillingDay
            driverStages: $driverStages
            carStatusIn: $carStatusIn
            driverTags: $driverTags
            hasPaymentPlan: $hasPaymentPlan
            hasPaymentSchedule: $hasPaymentSchedule
            driverInOffice: $driverInOffice
            autoCharge: $autoCharge
            retriesExhausted: $retriesExhausted
            openingBalance_Gte: $openingBalanceGte
            openingBalance_Lte: $openingBalanceLte
            openedAt_Date_Gte: $openedAtDateGte
            openedAt_Date_Lte: $openedAtDateLte
            assignedToId: $assignedToId
            assignedToIds: $assignedToIds
        )
    }
`

export const UPDATE_COLLECTION_CASE_ASSIGNMENT = gql`
    mutation UpdateCollectionCaseAssignment(
        $caseId: Int!
        $assignedToIds: [ID]!
    ) {
        updateCollectionCaseAssignment(
            input: { caseId: $caseId, assignedToIds: $assignedToIds }
        ) {
            ok
            caseId
            errors {
                field
                messages
            }
        }
    }
`

export const COLLECTION_BRANCHES = gql`
    query CollectionBranches {
        allBranches(isActive: true, isUserScoped: true) {
            edges {
                node {
                    id
                    pk
                    name
                }
            }
        }
    }
`

export const COLLECTION_DRIVER_TAGS = gql`
    query CollectionDriverTags {
        allTags(contentType: 13) {
            edges {
                node {
                    id
                    name
                    color
                }
            }
        }
    }
`

export const COLLECTION_COLLECTORS = gql`
    query CollectionCollectors($searchTerm: String, $first: Int) {
        allReps(
            isStaff: true
            isActive: true
            groups: ["Collectors"]
            orderBy: ["username"]
            searchTerm: $searchTerm
            first: $first
        ) {
            edges {
                node {
                    id
                    name
                    username
                    firstName
                    lastName
                }
            }
        }
    }
`

export const DRIVER_PAYMENT_SCHEDULES = gql`
    query DriverPaymentSchedules($driverId: ID!, $first: Int, $after: String) {
        allPaymentSchedules(driverId: $driverId, first: $first, after: $after, orderBy: ["-schedule_datetime"]) {
            edges {
                cursor
                node {
                    id
                    pk
                    status
                    amountToCharge
                    scheduleDatetime
                    notes
                    dateAdded
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
                startCursor
            }
        }
    }
`

export const CASE_ACTIVITIES = gql`
    query CaseActivities($caseId: Int!) {
        allCollectionActivities(caseId: $caseId) {
            id
            caseId
            activityType
            count
            note
            createdById
            dateAdded
        }
    }
`

export const CREATE_COLLECTION_ACTIVITY = gql`
    mutation CreateCollectionActivity(
        $caseId: Int!
        $activityType: String!
        $note: String
    ) {
        createCollectionActivity(
            input: { caseId: $caseId, activityType: $activityType, note: $note }
        ) {
            ok
            activityId
            activityType
            note
            dateAdded
            createdById
            errors {
                field
                messages
            }
        }
    }
`

export const CLOSE_COLLECTION_CASE = gql`
    mutation CloseCollectionCase($caseId: Int!, $note: String) {
        closeCollectionCase(input: { caseId: $caseId, note: $note }) {
            ok
            caseId
            errors {
                field
                messages
            }
        }
    }
`

export const COLLECTION_AGGREGATES = gql`
    query CollectionAggregates($startDate: Date, $endDate: Date) {
        collectionAggregates(startDate: $startDate, endDate: $endDate) {
            openCount
            closedCount
            outstandingTotal
            collectedTotal
            agingBuckets {
                d07
                d714
                d1430
                d30Plus
            }
            collectedTrend {
                date
                amount
            }
        }
    }
`

export const COLLECTIONS_SAVED_VIEWS = gql`
    query CollectionsSavedViews {
        currentUser {
            id
            member {
                id
                collectionsSavedViews
            }
        }
    }
`

export const UPDATE_COLLECTIONS_SAVED_VIEWS = gql`
    mutation UpdateMemberCollectionsViews(
        $memberId: ID!
        $savedViews: JSONString!
    ) {
        updateMemberCollectionsViews(
            input: { memberId: $memberId, savedViews: $savedViews }
        ) {
            ok
            errors {
                field
                messages
            }
        }
    }
`
